<template>
  <div class="user">
    <van-nav-bar v-if="isWx" class="navBar" left-arrow title="莞工通讯录" z-index="99" @click-left="back"/>
    <div class=" bg-white" style="width:100%;height:200px;">
      <div class="pt-2  text-center " style="width:100%; display:flex; justify-content:center;">

        <van-image v-if="form.avatar" :src=" url + form.avatar" fit="cover" height="70px" lazy-load
                   round width="70px"
                   @click="showhead(form.avatar)"
        >
          <template v-slot:error>
            <div class="headImageName" style="">{{ headName }}</div>
          </template>
          <template v-slot:loading>
            <van-loading size="20" type="spinner"/>
          </template>
        </van-image>

        <div v-else class="headImage">
          <div class="headImageName" style="">{{ headName }}</div>
        </div>
      </div>

      <div>
        <p>{{ form.nickName }}
          <span v-if="form.userType==3" class="TSlabel" style="background-color:#3ca31b">学生</span>
          <span v-if="form.userType==2" class="TSlabel" style="background-color:cornflowerblue">教师</span></p>
        <p v-if="form.userType==2" style="font-size:14px;color:#9b9b9b">{{ form.deptName }}</p>
        <p v-if="form.userType==3" style="font-size:14px;color:#9b9b9b">{{ form.className }}</p>
      </div>
    </div>
    <div style="height:10px;width:100%;background-color:#f7f7f7"></div>
    <div class=" bg-white">
      <div class="flex justify-between border-bottom py-1_5 px-1_5">
        <div class="AMIBIOS">账号</div>
        <div style="color:#898989">{{ form.userName }}</div>
      </div>
      <div class="flex justify-between border-bottom py-1_5 px-1_5">
        <div class="AMIBIOS">邮箱</div>
        <div style="color:#898989">{{ form.email }}</div>
      </div>
      <div class="flex justify-between border-bottom py-1_5 px-1_5">
        <div class="AMIBIOS">微信号</div>
        <div style="color:#898989">{{ form.weChat }}</div>
      </div>
      <div class="flex justify-between border-bottom py-1_5 px-1_5">
        <div class="AMIBIOS">QQ</div>
        <div style="color:#898989">{{ form.qqNumber }}</div>
      </div>
      <div class="flex justify-between border-bottom py-1_5 px-1_5">
        <div class="AMIBIOS">短号</div>
        <div style="color:#898989" @click="call(form.cornet)">{{ form.cornet }}</div>
      </div>
      <div v-if="form.userType==2" class="flex justify-between border-bottom py-1_5 px-1_5">
        <div class="AMIBIOS">办公室号码</div>
        <div style="color:#898989">
          <van-icon :color="icon.color" name="phone"/>
          <span @click="call(form.telephone)">{{ form.telephone }}</span></div>
      </div>
      <div class="flex justify-between border-bottom py-1_5 px-1_5">
        <div class="AMIBIOS">手机号</div>
        <div style="color:#898989" @click="call(form.phonenumber)">
          <van-icon :color="icon.color" name="phone"/>
          {{ form.phonenumber }}
        </div>
      </div>
    </div>
    <van-popup v-model="inputShow" round style="width:80%;height:200px">
      <div class="pt-3 " style="font-size:16px;font-weight:600">{{ updataTitle }}</div>
      <div class="px-2 pt-3 inputCss">
        <input v-if="ShowInput=='email'" v-model="newform.email" class="border" maxlength="30" placeholder="请输入邮箱"
               type="email"/>
        <input v-if="ShowInput=='weChat'" v-model="newform.weChat" class="border" maxlength="20" placeholder="请输入微信号"
               type="text"/>
        <input v-if="ShowInput=='qqNumber'" v-model="newform.qqNumber" class="border"
               oninput="if(value.length>13)value=value.slice(0,13)" placeholder="请输入QQ" type="number"/>
        <input v-if="ShowInput=='cornet'" v-model="newform.cornet" class="border"
               oninput="if(value.length>13)value=value.slice(0,13)" placeholder="请输入短号" type="number"/>
        <input v-if="ShowInput=='telephone'" v-model="newform.telephone" class="border"
               oninput="if(value.length>13)value=value.slice(0,13)" placeholder="请输入办公室号码" type="number"/>
      </div>

      <div class="pt-3">
        <van-button class="px-2" color="#1aa32b" size="small" style="border-radius:5px" @click="submit">修 改
        </van-button>
        <van-button class="ml-4 px-2" size="small" style="border-radius:5px" @click="close">关 闭</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {GetInfo, update} from '@/network/common'
import {ImagePreview} from 'vant';

export default {
  data() {
    return {
      url: process.env.VUE_APP_BASE_API || '',
      isWx: false,
      icon: {
        color: '#009100',
        size: 20
      },
      titlePopup: '',//弹窗标题
      inputShow: false,
      ShowInput: '',//
      form: {
        className: null,
        classNo: null,
        deptId: null,
        deptName: null,
        email: null,
        nickName: '',
        phonenumber: null,
        qqNumber: null,
        cornet: null,    //短号
        telephone: null,    //办公室电话
        userId: null,
        userName: null,
        userType: null,
        weChat: null,
      },
      updataTitle: '编辑信息',
      newform: {}
    }
  },
  created() {
    this.getList()
  },
  mounted() {

  },
  activated() {

    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      this.isWx = true
    } else {
      this.isWx = false
    }
    this.getList()
  },

  methods: {
    getList() {
      GetInfo(this.$route.query.id).then(res => {
        if (res.code == 200) {
          this.form = res.data
          this.newform = res.data
        }
      })
    },
    //提交修改
    submit() {
      let data = {
        userId: this.newform.userId,
        cornet: this.newform.cornet,
        qqNumber: this.newform.qqNumber,
        weChat: this.newform.weChat,
        email: this.newform.email,
        telephone: this.newform.telephone,
      }
      update(data).then(res => {
        if (res.code = 200) {
          this.$toast.success('修改成功');
          this.getList()
        }

      })
    },
    inputShowMessage(data) {
      this.inputShow = true
      this.ShowInput = data
      this.titlePopup = ''
    },
    close() {
      this.inputShow = false
      this.getList()
    },
    call(phone) {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        this.isWx = true
        if (phone) {
          window.location.href = 'tel://' + phone
        }
      } else {
        this.isWx = false
        if (phone) {
          window.location.href = 'tel:' + phone
        }
      }

    },
    back() {
      this.$router.back(-1)
    },
    showhead(data) {
      ImagePreview({
        images: [
          this.url + data
        ],
        overlayStyle: {

          backgroundColor: 'rgba(0,0,0,75%)'
        },
        closeable: true,
      });
    },
    maxnnuber(value) {
      if (value.length > 13) value = value.slice(0, 13)
    },
  },
  computed: {
    headName() {
      return this.form.nickName.substring(0, 1).toUpperCase()
    }
  },
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  }
}
</script>

<style>
.user .py-1_5 {
  padding-top: 15px;
  padding-bottom: 15px;
}

.user {
  background-color: #f7f7f7;
  height: 100vh;
}

.user .van-nav-bar .van-icon {
  color: white;
}

.user .headImage {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: #f3f3f3;
}

.user .headImageName {
  font-size: 28px;
  font-weight: 500;
  line-height: 70px;
  color: #adadad
}

.user .AMIBIOS {
  width: 80px;
  text-align: left;
  font-size: 14px;
  font-family: '思源黑体 CN';
}

.inputCss input {
  padding: 5px 5px;
  border-radius: 4px;
}

.user .TSlabel {
  font-size: 8px;
  color: white;
  padding: 1px;
}
</style>
